import Model from './Model'
import Avatar from './Avatar'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class User extends Model {
  resource() {
    return 'users'
  }

  avatar() {
    return this.hasMany(Avatar)
  }

  get avatarText() {
    return this.first_name.charAt(0) + this.last_name.charAt(0)
  }

  get roleText() {
    if (!this.roles || !this.roles.length) return ''
    let roles = null

    /**
     * Special case:
     * Change `sparky` to `contractor`
     */
    const getSparkyLabel = r =>
      r.toUpperCase() === 'SITE_SPARKY'
        ? 'contractor'
        : r.toUpperCase() === 'SITE_HEAD_SPARKY'
        ? 'head contractor'
        : r
    if (Array.isArray(this.roles)) {
      roles = this.roles.map(role => getSparkyLabel(role)).join(' | ')
    } else {
      roles = getSparkyLabel(roles)
    }

    return (
      roles
        .toString()
        .replaceAll('_', ' ')
        /* Set to lowercase and let CSS handle the capitalization */
        .toLowerCase()
    )
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
